









































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { CarrierProductCommission } from '@/modules/CarrierProduct/interfaces/carrier-product-commission'

@Component({})
export default class PremiumCommissionSelector extends Vue {
  @Prop(Array) commissions!: CarrierProductCommission[]

  get height () {
    const { commissions } = this
    return commissions.length
      ? Math.min(
        commissions.length * 57,
        350
      )
      : 57
  }

  @Emit('click')
  handleClick (index: number) {
    return index
  }
}
